import React from 'react';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
export default React.PropTypes.shape({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  typeName: React.PropTypes.oneOf(['singleLineInput']).isRequired,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  definition: React.PropTypes.shape({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
    input: React.PropTypes.string,
  }).isRequired,
});
